import React from "react";
import { DevIcons } from "./DevDashboardIcons";

const renderIcon = (type, color) => {
  switch (type) {
    case "cube":
      return <DevIcons.Cube size={18} color={color} />;
    case "workflow":
      return <DevIcons.Workflow size={18} color={color} />;
    case "play":
      return <DevIcons.PlayCircle size={18} color={color} />;
    case "checkCircle":
      return <DevIcons.CheckCircle size={18} color={color} />;
    case "revenue":
      return <DevIcons.Revenue size={18} color={color} />;
    case "star":
      return <DevIcons.Star size={18} color={color} fill={color} />;
    case "clock":
      return <DevIcons.Clock size={18} color={color} />;
    default:
      return <DevIcons.Cube size={18} color={color} />;
  }
};

const DevKpiCards = ({ cards = [] }) => {
  return (
    <div className="dev-kpi-grid">
      {cards.map((card) => {
        return (
          <div key={card.id} className="dev-kpi-card">
            <div
              className="dev-kpi-icon-box"
              style={{ backgroundColor: card.iconBg }}
            >
              {renderIcon(card.iconType, card.iconColor)}
            </div>

            <div className="dev-kpi-body">
              <span className="dev-kpi-title">{card.title}</span>

              <div className="dev-kpi-value-row">
                <span className="dev-kpi-value">{card.value}</span>
                {card.ratingCount && (
                  <span className="dev-kpi-rating-count">
                    ({card.ratingCount})
                  </span>
                )}
              </div>

            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DevKpiCards;
